import React, { Component } from 'react';
import CommonModal from '../CommonModal';
import './index.scss'
class ActivityRule extends Component {
  state = {
    modalVisible: false,
  }

  toggleModal = () => {
    this.setState(prevState=>({ modalVisible: !prevState.modalVisible }))
  }

  render() {
    const { style, modalBgColor, ruleImgUrl } = this.props;
    const { modalVisible } = this.state;
    return (<>
      <div className="activity-rule" style={{ backgroundImage: `url(${ruleImgUrl})`, ...style }} onClick={this.toggleModal}>
      </div>
      <CommonModal closeBtn visible={modalVisible} modalBgColor={modalBgColor} onClose={this.toggleModal} >{this.props.children}</CommonModal>
    </>);
  }
}

export default ActivityRule;